import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { HotToastService } from '@ngneat/hot-toast';

import { UserOrderDetailDto } from 'src/app/core/dtos/dto';
import { AccountService } from 'src/app/core/services/account.service';

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.scss']
})
export class OrderDetailsComponent implements OnInit {

  title: string;
  orderNumber: number;
  orderDetail: UserOrderDetailDto;
  totalSavings = 0;

  constructor(
    private actRoute: ActivatedRoute,
    private accountService: AccountService,
    private toastService: HotToastService,
  ) {
    this.orderNumber = this.actRoute.snapshot.params.id;
  }

  ngOnInit(): void {
    this.getDetail(this.orderNumber);
  }

  getDetail(id: number) {
    this.accountService.getOrderDetail(id)
      .subscribe(
        result => {
          this.orderDetail = result.content;

          this.orderDetail.orderItems.forEach(x => {
            this.totalSavings += x.discountAmount;
          });

          this.title = `VIEW ORDER # ${this.orderDetail.orderNumber}`;
        },
        (error: HttpErrorResponse) => {
          if (error.status !== 401) {
            this.toastService.warning("Unable to load page");
          }
        });
  }
}
